import { rewordValidationMessages } from '#api/errors.ts';
import type { BillingDetails } from '#dn-types/billing.ts';
import { get, post } from './fetch.ts';

// GET /v1/billing/details
export type GetBillingDetailsResult = BillingDetails;
export function getBillingDetails(init?: RequestInit) {
  return get<GetBillingDetailsResult>('/v1/billing/details', init);
}

// POST /v1/billing/update-plan
export type CancelPlanResult = { subscriptionStatus: string };
export function cancelPlan() {
  return post<CancelPlanResult>(
    '/v1/billing/cancel-plan',
    {} // Convert from server error codes to more friendly strings, if possible
  ).catch((err: unknown) => {
    rewordValidationMessages(err, (details) => {
      // ERR_BILLING_INVALID_STATE returned if they don't have a subscription
      if (details.path === undefined && details.code === 'ERR_BILLING_INVALID_STATE') {
        return 'You don’t have a subscription to cancel.';
      }
    });
  });
}

// POST /v1/stripe/setup-intent
export type StartSetupIntentResult = { clientSecret: string };
export function startSetupIntent() {
  return post<StartSetupIntentResult>('/v1/stripe/setup-intent', {});
}

// POST /v1/stripe/verify-setup-intent
type VerifySetupIntentVariables = {
  setupIntent: string;
  setupIntentClientSecret: string;
};
export type VerifySetupIntentResult = { subscriptionStatus: 'none' | 'active' | string };
export function setupIntentSuccess(data: VerifySetupIntentVariables) {
  return (
    post<VerifySetupIntentResult>('/v1/stripe/verify-setup-intent', data)
      // Convert from server error codes to more friendly strings, if possible
      .catch((err: unknown) => {
        rewordValidationMessages(err, (details) => {
          // ERR_BILLING_INVALID_STATE returned when they already have a subscription
          if (details.path === undefined && details.code === 'ERR_BILLING_INVALID_STATE') {
            return 'You already have a subscription.  Please try again or contact support for help.';
          }

          // ERR_BILLING_SETUP_INTENT_PAYMENT_METHOD_REQUIRED returned if verifying the intent fails
          if (details.path === undefined && details.code === 'ERR_BILLING_SETUP_INTENT_PAYMENT_METHOD_REQUIRED') {
            return 'Setting up your payment method failed, please try again.';
          }
        });
      })
  );
}

// POST /v1/stripe/customer-portal
export type ShowCustomerPortalResult = { redirectURL: string };
export function showCustomerPortal() {
  return post<ShowCustomerPortalResult>('/v1/stripe/customer-portal', {});
}
